module.exports = __webpack_public_path__ + "img/kenya.7de0c81.webp";